import listingImage1 from './images/featured_listing_1.jpg';
import listingImage2 from './images/featured_listing_2.jpg';
import listingImage3 from './images/featured_listing_3.jpg';
import avatarImage1 from './images/avatar_1.jpg';
import avatarImage2 from './images/avatar_2.jpeg';
import avatarImage3 from './images/avatar_3.jpg';

export const linksProps = {
  listing1: {
    id: '5eecdc7e-97da-460a-ab1b-cf9fb5659c05',
    title: ' Preciosa piscina (14x7). En Boadilla del Monte.',
    price: '500',
    image: listingImage1,
    provider: {
      avatar: avatarImage1,
      displayName: 'Juan Jose B',
      abbreviatedName: 'JB',
    },
  },
  listing2: {
    id: '5ef35072-1ed7-4ab2-8358-3acb07b648c5',
    title: 'Piscina privada al pie de la pedriza a 40 minutos de Madrid',
    price: '400',
    image: listingImage2,
    provider: {
      avatar: avatarImage2,
      displayName: 'Rafael G',
      abbreviatedName: 'RG',
    },
  },
  listing3: {
    id: '5d5a6a54-1af0-4f15-b550-487e9d9382de',
    title: 'Piscina con vistas espectaculares a 20 km de Barcelona',
    price: '500',
    image: listingImage3,
    provider: {
      avatar: avatarImage3,
      displayName: 'Luis V',
      abbreviatedName: 'LV',
    },
  },
};
